import { sfxCore } from "@/lib/celebrate";

const { audio, out, on } = sfxCore;
const ID = "candy";
const play = (fn) => { if (!on(ID)) return; const a = audio(); if (a) fn(a); };

const bell = (a, t, f, { dur = 0.5, vol = 0.08, type = "sine" } = {}) => {
  const at = a.currentTime + t;
  [[1, vol], [2.76, vol * 0.25], [5.4, vol * 0.08]].forEach(([m, v]) => {
    const o = a.createOscillator(), g = a.createGain();
    o.type = m === 1 ? type : "sine"; o.frequency.setValueAtTime(f * m, at);
    g.gain.setValueAtTime(0.0001, at); g.gain.exponentialRampToValueAtTime(v, at + 0.006); g.gain.exponentialRampToValueAtTime(0.0001, at + dur / m ** 0.4);
    o.connect(g).connect(out(a)); o.start(at); o.stop(at + dur + 0.05);
  });
};

const noise = (a, t, { dur = 0.3, vol = 0.1, from = 2000, to = 300, q = 0.8 } = {}) => {
  const at = a.currentTime + t, len = Math.floor(a.sampleRate * dur);
  const buf = a.createBuffer(1, len, a.sampleRate), d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
  const s = a.createBufferSource(), f = a.createBiquadFilter(), g = a.createGain();
  s.buffer = buf; f.type = "bandpass"; f.Q.value = q; f.frequency.setValueAtTime(from, at); f.frequency.exponentialRampToValueAtTime(to, at + dur);
  g.gain.setValueAtTime(vol, at); g.gain.exponentialRampToValueAtTime(0.0001, at + dur);
  s.connect(f).connect(g).connect(out(a)); s.start(at);
};

const sweep = (a, t, from, to, dur, vol, type = "sine") => {
  const at = a.currentTime + t, o = a.createOscillator(), g = a.createGain();
  o.type = type; o.frequency.setValueAtTime(from, at); o.frequency.exponentialRampToValueAtTime(to, at + dur);
  g.gain.setValueAtTime(0.0001, at); g.gain.exponentialRampToValueAtTime(vol, at + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, at + dur);
  o.connect(g).connect(out(a)); o.start(at); o.stop(at + dur + 0.05);
};

const SCALE = [523.25, 587.33, 659.25, 783.99, 880, 1046.5, 1174.66, 1318.5, 1568, 1760];

export const czSwap = () => play((a) => { noise(a, 0, { dur: 0.12, vol: 0.05, from: 1800, to: 700 }); sweep(a, 0, 420, 620, 0.1, 0.03); });
export const czInvalid = () => play((a) => { bell(a, 0, 220, { dur: 0.18, vol: 0.05, type: "triangle" }); bell(a, 0.09, 196, { dur: 0.22, vol: 0.05, type: "triangle" }); });
export const czMatch = (cascade) => play((a) => {
  const f = SCALE[Math.min(SCALE.length - 1, cascade - 1)];
  bell(a, 0, f, { dur: 0.45, vol: 0.075 }); bell(a, 0.035, f * 1.5, { dur: 0.35, vol: 0.035 });
  noise(a, 0, { dur: 0.08, vol: 0.025, from: 6000, to: 3000, q: 2 });
});
export const czCreate = () => play((a) => [1318.5, 1568, 2093, 2637].forEach((f, i) => bell(a, i * 0.045, f, { dur: 0.4, vol: 0.04 })));
export const czStripe = () => play((a) => { sweep(a, 0, 300, 2400, 0.28, 0.05, "triangle"); noise(a, 0, { dur: 0.3, vol: 0.06, from: 900, to: 6000, q: 1.2 }); });
export const czWrap = () => play((a) => { sweep(a, 0, 140, 38, 0.6, 0.22); noise(a, 0, { dur: 0.5, vol: 0.12, from: 1200, to: 120, q: 0.6 }); bell(a, 0.05, 784, { dur: 0.5, vol: 0.03 }); });
export const czBomb = () => play((a) => { SCALE.forEach((f, i) => bell(a, i * 0.03, f * 2, { dur: 0.5, vol: 0.03 })); sweep(a, 0, 90, 35, 0.9, 0.2); noise(a, 0.05, { dur: 0.9, vol: 0.08, from: 4000, to: 200 }); });
export const czIce = () => play((a) => { noise(a, 0, { dur: 0.16, vol: 0.06, from: 7000, to: 3500, q: 3 }); bell(a, 0, 2637, { dur: 0.2, vol: 0.02 }); });
export const czStar = (i) => play((a) => { bell(a, 0, [1046.5, 1318.5, 1568][i] || 1568, { dur: 1.1, vol: 0.09 }); bell(a, 0.06, ([1046.5, 1318.5, 1568][i] || 1568) * 2, { dur: 0.7, vol: 0.03 }); });
export const czWin = () => play((a) => [523.25, 659.25, 783.99, 1046.5, 1318.5].forEach((f, i) => bell(a, i * 0.11, f, { dur: 1.2, vol: 0.07 })));
export const czFail = () => play((a) => [659.25, 587.33, 523.25, 392].forEach((f, i) => bell(a, i * 0.16, f, { dur: 0.8, vol: 0.05, type: "triangle" })));
export const czCrush = () => play((a) => { [1568, 2093, 2637, 3136].forEach((f, i) => bell(a, i * 0.05, f, { dur: 0.6, vol: 0.035 })); noise(a, 0, { dur: 0.4, vol: 0.04, from: 8000, to: 3000, q: 2 }); });
export const czTap = () => play((a) => bell(a, 0, 1318.5, { dur: 0.12, vol: 0.025 }));
export const czShuffle = () => play((a) => { for (let i = 0; i < 8; i++) bell(a, i * 0.04, SCALE[(i * 3) % SCALE.length], { dur: 0.25, vol: 0.025 }); });
